module.exports = __webpack_public_path__ + "img/pw.83e46012.svg";